import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import illustration from '../../assets/empty-state.svg'
export const EmptyState = ({ msg }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <img src={illustration} alt="Empty state illustration" />
            <Typography color="neutral" level="body-lg">
                {msg}
            </Typography>
        </Box>
    )
}
